import Device from '../Device';
import vp from '../../../services/api/vp';

const questions = [{
  name: 'eguana',
  type: 'eguana',
  active: true,
  showNext: true,
  advanceOnEnter: true,
  advanceOnValue: true,
}];

async function fetchPairingCode() {
  const data = await vp.getPairingCode({
    mfg: 'eguana',
  });
  return data.value;
}

const addDevice = async (values, context) => {
  const pairingCode = await fetchPairingCode();
  const deviceData = {
    ...values,
    mfg: 'eguana',
    deviceType: 'battery',
    shellDevice: true,
    pairingCode,
    ...Device.commonAddDeviceParameters(context),
  };

  return vp.addDevice(deviceData);
};

const Eguana = new Device('eguana', { mfg: 'eguana', questions, addDevice });

export default Eguana;
